import React from "react"
import moment from "moment"
import { Button, DatePicker, Form, Input, Select } from "antd"
import { DownloadOutlined, ReloadOutlined } from "@ant-design/icons"
import { stageOptions, statusOptions } from "./labels"

// Период — даты по Москве включительно, не длиннее года.
export function AuthRequestsFilters({ filters, onApply, onRefresh, onExport, canExport, isLoading, isExporting }) {
  const [form] = Form.useForm()

  function onFinish(values) {
    onApply({
      dateFrom: values.range[0].format("YYYY-MM-DD"),
      dateTo: values.range[1].format("YYYY-MM-DD"),
      phone: (values.phone ?? "").trim(),
      method: values.method ?? null,
      status: values.status ?? null,
    })
  }

  return (
    <Form
      form={form}
      layout="inline"
      style={{ marginBottom: 16, rowGap: 8 }}
      initialValues={{
        range: [moment(filters.dateFrom), moment(filters.dateTo)],
        phone: filters.phone,
        method: filters.method ?? undefined,
        status: filters.status ?? undefined,
      }}
      onFinish={onFinish}
    >
      <Form.Item name="range" label="Период">
        <DatePicker.RangePicker
          format="DD.MM.YYYY"
          allowClear={false}
          disabledDate={(day) => day && day.isAfter(moment(), "day")}
          ranges={{
            Сегодня: [moment(), moment()],
            "7 дней": [moment().subtract(6, "days"), moment()],
            "30 дней": [moment().subtract(29, "days"), moment()],
            "Этот месяц": [moment().startOf("month"), moment()],
          }}
        />
      </Form.Item>
      <Form.Item name="phone">
        <Input.Search
          placeholder="Номер телефона"
          allowClear
          maxLength={32}
          style={{ width: 200 }}
          onSearch={() => form.submit()}
        />
      </Form.Item>
      <Form.Item name="method">
        <Select placeholder="Способ" allowClear options={stageOptions} style={{ width: 230 }} />
      </Form.Item>
      <Form.Item name="status">
        <Select placeholder="Статус" allowClear options={statusOptions} style={{ width: 150 }} />
      </Form.Item>
      <Form.Item>
        <Button type="primary" htmlType="submit" loading={isLoading}>
          Показать
        </Button>
      </Form.Item>
      <Form.Item>
        <Button icon={<ReloadOutlined />} onClick={onRefresh} disabled={isLoading} title="Обновить" />
      </Form.Item>
      {canExport && (
        <Form.Item>
          <Button icon={<DownloadOutlined />} onClick={onExport} loading={isExporting}>
            Выгрузить CSV
          </Button>
        </Form.Item>
      )}
    </Form>
  )
}
